import { constants, mixpanel } from 'common/helpers'

import { ShippingType } from 'pages/paymentNew/SubscribePage/util/forms'

import syncUserAndSubscription from './syncUserAndSubscription'


// it's a simplest way to pass data from begin to commit,
// bcs both methods are called in different paypal button callbacks
let _token: string
let _payPalToken: string
let _payPalSession: string
let _paypalSessionId: string

type BeginPayPalValues = {
  plan: string
  paymentMethod: string
  billing: ShippingType
  shipping: ShippingType
}

type SetupBeginPayPalValues = {
  begin: (BeginPayPalValues) => any
  sessionName: string
}

const setupBeginPayPal = ({ begin, sessionName }: SetupBeginPayPalValues) => (values: BeginPayPalValues) => {
  mixpanel.track(constants.analyticsEvents.tech.beginPaypal)

  return begin(values)
    .then(
      ({ gatewaySessionId, paypalToken, [sessionName]: session, token }) => {
        _token = token
        _payPalToken = paypalToken
        _payPalSession = session
        _paypalSessionId = gatewaySessionId

        return paypalToken
      })
}


type CommitPayPalValues = {
  paymentType: string
  paypalSessionId: string
}

type SetupCommitPayPalValues = {
  commit: (any) => any
  sessionName: string
}

const setupCommitPayPal = ({ commit, sessionName }: SetupCommitPayPalValues) => (
  ({ paymentType, paypalSessionId }: CommitPayPalValues) => {
    const body = {
      token: _token,
      paypalToken: _payPalToken,
      [sessionName]: _payPalSession,
      paypalSessionId: paypalSessionId || _paypalSessionId,
    }

    mixpanel.track(constants.analyticsEvents.tech.commitPaypal)

    return commit(body)
      .then(
        (result) => {
          syncUserAndSubscription({ ...result, paymentType })

          return result
        })
  }
)


export {
  setupBeginPayPal,
  setupCommitPayPal,
}
